import { FunctionComponent } from "react"
import * as Icons from "@nova/component-icons"
import { Status } from "@nova/ds-component-status"
import { Tooltip } from "panels/content/top-bar/TODO-put-in-package/Tooltip"
import { DroneCategory, droneCategories } from "@nova/constants"
import { CurrencyPolicyStatus, summarizeCurrencyStatuses } from "./usePilotCurrencyStatuses"

const metricLabel = (s: CurrencyPolicyStatus) => `${s.progress} of ${s.threshold} ${s.metric}`

const droneTypeLabel = (droneTypes: string[]) =>
    droneTypes.length > 0
        ? droneTypes
              .map((k) =>
                  k in droneCategories ? droneCategories[k as DroneCategory].displayName : k
              )
              .join(", ")
        : "All drone types"

const singlePolicyLabel = (s: CurrencyPolicyStatus) =>
    s.metric === "flights"
        ? `${s.progress} of ${s.threshold} flights flown`
        : `${s.progress} of ${s.threshold} hours recorded`

const stateLabel: Record<CurrencyPolicyStatus["state"], string> = {
    overdue: "Overdue",
    upcoming: "Upcoming",
    current: "Current",
}

export const PilotCurrencyBadge: FunctionComponent<{ statuses: CurrencyPolicyStatus[] }> = ({
    statuses,
}) => {
    if (!statuses.length) return null

    const summary = summarizeCurrencyStatuses(statuses)

    if (summary.state === "current") {
        return (
            <Status
                type="positive"
                variant="outline"
                className="flex items-center p-1 !bg-black-600"
            >
                <Icons.SmallIcon Icon={Icons.BrowseGallery} />
            </Status>
        )
    }

    return (
        <div className="relative group/tooltip w-fit">
            <Status
                type={summary.state === "overdue" ? "error" : "warning"}
                variant="outline"
                className="flex items-center gap-1 py-1 px-2 !bg-black-600 whitespace-nowrap"
            >
                <Icons.SmallIcon Icon={Icons.BrowseGallery} />
                {summary.label}
            </Status>
            <Tooltip>
                {statuses.length === 1 ? (
                    <div className="whitespace-nowrap">{singlePolicyLabel(statuses[0])}</div>
                ) : (
                    <div className="flex flex-col gap-1">
                        {statuses
                            .toSorted((a, b) => (a.daysLeft ?? -1) - (b.daysLeft ?? -1))
                            .map((s) => (
                                <div key={s.policyId} className="whitespace-nowrap">
                                    {stateLabel[s.state]} • {metricLabel(s)} (
                                    {droneTypeLabel(s.droneTypes)})
                                </div>
                            ))}
                    </div>
                )}
            </Tooltip>
        </div>
    )
}
